import { Routes, Route } from "react-router-dom";
import "../App.css";
import Header from "../Components/USER/Uheader";
import Landing from "./Landing";
import Bag from "./bag";
import Footer from "../Components/USER/footer";
import Wishlist from "./Wishlist";
import OrderHistory from "../Components/USER/Orderhistory";
import Profile from "./Profile";
import { useEffect, useRef, useState } from "react";
import ParticularProduct from "../Components/USER/ParticularProduct";
import Scrolltop from "../Components/Scrolltop";
import axios from "axios";
import { toast } from "react-toastify";

function Userhomepage() {
  const scrollContainerRef = useRef(null);
  const fetchedRef = useRef(false);

  const [header, setHeader] = useState([]);
  const [products, setProducts] = useState([]);
  const [bag, setBag] = useState([]);
  const [wishlist, setWishlist] = useState([]);

  const userData = JSON.parse(localStorage.getItem("userData") || "{}");

  const fetchHeaders = async () => {
    try {
      const formData = new FormData();
      formData.append("type", "customer");

      const res = await fetch(
        `${process.env.REACT_APP_BASEURL}/apis/vendor/category_show.php`,
        {
          method: "POST",
          body: formData,
        }
      );

      const result = await res.json();

      if (result.status === "success") {
        const categories = result.data.flatMap(item => item.categories);
        setHeader(categories);
      }
    } catch (error) {
      console.error("Submit failed", error);
    }
  };

  const fetchproducts = async () => {
    const formData = new FormData();
    formData.append("type", "customer");

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BASEURL}/apis/prod_show.php`,
        formData
      );
      const rawData = res.data?.data;
      const data = Array.isArray(rawData) ? rawData : [];
      setProducts([...data]);
    } catch (err) {
      console.error("Error fetching wishlist", err);
      setProducts([]);
    }
  };

  const fetchbag = async (type) => {
    if (!userData?.id) {
      if (type === "cart") {
        setBag([]);
      } else if (type === "wishlist") {
        setWishlist([]);
      }
      return;
    } else {
      const formData = new FormData();
      formData.append("type", type);
      formData.append("cust_id", userData?.id);

      try {
        const res = await axios.post(
          `${process.env.REACT_APP_BASEURL}/apis/customer/cart_show.php`,
          formData
        );
        const rawData = res.data?.data;
        const data = Array.isArray(rawData) ? rawData : [];
        if (type === "cart") {
          setBag([...data]);
        } else {
          setWishlist([...data]);
        }
      } catch (err) {
        console.error("Error fetching bag", err);
        setBag([]);
      }
    }
  };

  // const updateQuantity = async (id, delta) => {
  //   const updatedItems = bag.map((item) => {
  //     if (item.id === id) {
  //       const newQty = parseInt(item.quantity) + delta;
  //       return {
  //         ...item,
  //         quantity: newQty < 1 ? 1 : newQty,
  //       };
  //     }
  //     return item;
  //   });

  //   setBag(updatedItems);

  //   try {
  //     const formData = new FormData();
  //     formData.append("id", id);
  //     formData.append(
  //       "quantity",
  //       updatedItems.find((i) => i.id === id).quantity
  //     );

  //     await axios.post(
  //       `${process.env.REACT_APP_BASEURL}/apis/customer/cart_update.php`,
  //       formData
  //     );
  //   } catch (error) {
  //     console.error("Failed to update quantity in backend:", error);
  //   }
  // };
  const remove = async (option, id, type) => {
    const formData = new FormData();
    formData.append("option", option);
    formData.append("type", type || "wishlist");
    formData.append("cust_id", userData?.id);
    formData.append("id", id);

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BASEURL}/apis/customer/cart_delete.php`,
        formData
      );

      if (res.data.success) {
        toast.success(res.data.message || "Item removed");
        if (type === "cart") {
          if (typeof fetchbag === "function") {
            fetchbag("cart");
          }
        } else {
          if (typeof fetchbag === "function") {
            fetchbag("wishlist");
          }
        }
      } else {
        console.warn("Remove failed:", res.data.message || "Unknown error");
      }
    } catch (err) {
      console.error("Error removing item:", err);
    }
  };

  const updateQuantity = async (identifier, delta, bagtype) => {
    const item =
      bag.find((item) => item.id === identifier) ||
      bag.find((item) => item.product_id === identifier);

    if (!item) {
      console.warn("Item not found in bag for ID:", identifier);
      return;
    }

    const currentQty = parseInt(item.quantity);
    const newQty = currentQty + delta;

    if (newQty < 1) {
      await remove("delete", item.id || item.product_id, bagtype);
      return;
    }

    const updatedItems = bag.map((bagItem) =>
      bagItem.id === identifier || bagItem.product_id === identifier
        ? { ...bagItem, quantity: newQty }
        : bagItem
    );

    setBag(updatedItems);

    try {
      const formData = new FormData();
      formData.append("id", item.id);
      formData.append("quantity", newQty);

      await axios.post(
        `${process.env.REACT_APP_BASEURL}/apis/customer/cart_update.php`,
        formData
      );
    } catch (error) {
      console.error("Failed to update quantity in backend:", error);
    }
  };

  const [profile, setProfile] = useState(null);
  const [profileData, setProfileData] = useState({
    addressList: [],
  });

  const fetchProfileData = async () => {
    if (!userData) {
      setProfile(null);
      setProfileData({ addressList: [], canAddMore: true });
      return;
    } else {
      const formData = new FormData();
      formData.append("id", userData?.id);

      try {
        const res = await axios.post(
          `${process.env.REACT_APP_BASEURL}/apis/customer/customer_show.php`,
          formData
        );

        if (res.data.status === "success") {
          const profile = res.data.data?.[0] || {};
          let addressObj = {};
          try {
            addressObj = JSON.parse(profile.address || "{}");
          } catch (e) {
            console.error("Invalid address JSON", e);
          }

          const existingTypes = Object.keys(addressObj); // e.g., ['home', 'work']
          const canAddMore = existingTypes.length < 4;

          // Optional: Convert to array for rendering
          const addressList = existingTypes.map((type) => ({
            addressType: type,
            address: addressObj[type],
          }));

          // Save in state
          setProfile(profile);
          setProfileData({
            ...profile,
            addressList,
            canAddMore,
          });
        } else {
          console.warn("Empty or invalid response");
        }
      } catch (err) {
        console.error("Error fetching profile/address data:", err);
      }
    }
  };

  const profileupdate = async (payload, type) => {
    const formData = new FormData();
    formData.append("action", type);
    formData.append("id", userData?.id);
    if (type === "update") {
      formData.append("name", payload);
    } else if (type === "add") {
      formData.append("address[0][label]", payload?.label);
      formData.append("address[0][value]", payload?.value);
    } else {
      formData.append("delete_key", payload);
    }

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BASEURL}/apis/customer/customer_update.php`,
        formData
      );
      const rawData = res.data?.data;
      const data = Array.isArray(rawData) ? rawData : [];
      if (res.data?.status === "success") {
        fetchProfileData();
      } else {
        console.error("error on fetching");
      }
    } catch (err) {
      console.error("Error fetching bag", err);
    }
  };

  useEffect(() => {
    if (fetchedRef.current) return;

    fetchedRef.current = true;
    fetchproducts();
    fetchbag("wishlist");
    fetchbag("cart");
    fetchProfileData();
    fetchHeaders();
    if (!userData?.id) {
      setBag([]);
      setWishlist([]);
    }
  }, []);

  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    if (!scrollContainer) return;

    const handleScroll = () => {
      setIsScrolled(scrollContainer.scrollTop > 10);
    };

    scrollContainer.addEventListener("scroll", handleScroll);
    return () => scrollContainer.removeEventListener("scroll", handleScroll);
  }, [scrollContainerRef]);

  const [isScrolled, setIsScrolled] = useState(false);

  const bagcount = bag?.length;
  const wishlistcount = wishlist.length;

  return (
    <div className="app-containeer">
      {/* <Scrolltop />  */}
      <Scrolltop scrollContainerRef={scrollContainerRef} />
      <Header
        scrollContainerRef={scrollContainerRef}
        isScrolled={isScrolled}
        products={products}
        bagcount={bagcount}
        wishlistcount={wishlistcount}
        fetchbag={fetchbag}
        setBag={setBag}
        setWishlist={setWishlist}
        header={header}
      />
      <div
        ref={scrollContainerRef}
        style={{
          overflowY: "scroll",
          height: "100vh",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        }}
      >
        <div className="main-content">
          <Routes>
            <Route
              path=""
              element={
                <Landing
                  products={products}
                  fetchbag={fetchbag}
                  updateQuantity={updateQuantity}
                  bag={bag}
                  wishlist={wishlist}
                  remove={remove}
                />
              }
            />
            <Route
              path="bag"
              element={
                <Bag
                  bag={bag}
                  updateQuantity={updateQuantity}
                  remove={remove}
                  profile={profile}
                  profileupdate={profileupdate}
                />
              }
            />
            <Route
              path="wishlist"
              element={
                <Wishlist
                  wishlist={wishlist}
                  remove={remove}
                  fetchbag={fetchbag}
                  bag={bag}
                  updateQuantity={updateQuantity}
                  products={products}
                />
              }
            />
            <Route
              path="profile"
              element={
                <Profile
                  profile={profile}
                  fetchProfileData={fetchProfileData}
                  profileupdate={profileupdate}
                />
              }
            />
            <Route
              path="orders"
              element={
                <OrderHistory profile={profile} profileupdate={profileupdate} />
              }
            />
            <Route path="search" element={<Landing />} />
            <Route
              path="/productview/:id"
              element={
                <ParticularProduct
                  bag={bag}
                  fetchbag={fetchbag}
                  updateQuantity={updateQuantity}
                />
              }
            />
          </Routes>
        </div>
        <Footer
          scrollContainerRef={scrollContainerRef}
          isScrolled={isScrolled}
        />
      </div>
    </div>
  );
}

export default Userhomepage;
